const getIsChrome = () => {
  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  return isChrome;
};

export default getIsChrome;
